import { render, staticRenderFns } from "./Usuario.vue?vue&type=template&id=6c2078f0&scoped=true"
import script from "./Usuario.vue?vue&type=script&lang=js"
export * from "./Usuario.vue?vue&type=script&lang=js"
import style0 from "./Usuario.vue?vue&type=style&index=0&id=6c2078f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2078f0",
  null
  
)

export default component.exports